import React, { useState, useCallback, useEffect,useMemo } from 'react';
import { Card, Button, Form, Row, Col, Spinner,Collapse } from 'react-bootstrap';
import Subscription from "../../api/settings/Subscription";
import { responseValidate } from "../../utils/functions";
import { connect } from "react-redux";
import {setNewToast} from "../../store/reducers/App";
import Store from '../../store';
import { useHistory, useLocation } from 'react-router-dom';
import usePaymentMethods from "../../hooks/usePaymentMethods";
import StripeWrapper from '../../modules/payment/StripeWrapper';
import CardPaymentForm from '../../modules/payment/CardPaymentForm';
import BankPaymentForm from '../../modules/payment/BankPaymentForm';
import PaymentMethodSelector from '../../modules/payment/PaymentMethodSelector';

const SubscriptionPage = ({ store, darkMode }) => {
  const [planPrice, setPlanPrice] = useState('');
  const [status, setStatus] = useState(store?.store_subscription?.stripe_status || null);
  const [billingCycle, setBillingCycle] = useState('Monthly');
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredPlan, setFilteredPlan] = useState(null);
  const [plan, setPlan] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [planDetails, setPlanDetails] = useState(null);
  const [paymentType, setPaymentType] = useState('');
  const [selectedSavedPayment, setSelectedSavedPayment] = useState(null);
  const history = useHistory();
  const location = useLocation();

  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [showCouponInput, setShowCouponInput] = useState(false);

  const { savedCards, savedACH, clientSecret, fetchPaymentMethods, createSetupIntent, savePaymentMethod} = usePaymentMethods(store?.id);

  useEffect(() => {
    if (store?.coupon?.id) {
      setCouponCode(store?.coupon.id);
      setAppliedCoupon(store?.coupon);
    }
  }, [store?.coupon?.id]);

  const handlePaymentTypeChange = async(type) => {
    setPaymentType(type);
    setSelectedSavedPayment(null);
     if(type === 'payment-saved' || type === 'new-ach'){
      if(type === 'new-ach'){
        await createSetupIntent();
      }
    }
  };

  const handleApplyCoupon = async () => {
    if (!couponCode) {
      setCouponError('Please enter a referral code.');
      return;
    }
    setIsApplyingCoupon(true);
    setCouponError('');
    try {
      const response = await Subscription.validateCoupon({ coupon_code: couponCode, store_id: store?.id });
      const result = responseValidate(response);
      if (result.status) {
        setAppliedCoupon(result.data);
        Store.dispatch(setNewToast({
          body: result.message,
          variant: 'success'
        }));
      } else {
        setCouponError(result.message);
        setAppliedCoupon(null);
      }
    } catch (err) {
      setCouponError('Failed to validate referral code.');
      setAppliedCoupon(null);
      console.log(err);
    } finally {
      setIsApplyingCoupon(false);
    }
  };


  const fetchSubscriptions = useCallback(async () => {
    try {
      const response = await Subscription.index({ store_id: store?.id });
      const result = responseValidate(response);
      if (result.status) setSubscriptions(result?.data?.subscription);
    } catch (error) {
      console.error('Failed to fetch subscriptions', error);
    }
  }, [store]);

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      await Promise.all([fetchSubscriptions(),fetchPaymentMethods()]);
      setLoading(false);
    };
    fetchData();
  }, []);
  


const subscribeNow = async (paymentMethodId) => {

  const isSavedPayment =
    savedCards.some((c) => c.id === paymentMethodId) ||
    savedACH.some((b) => b.id === paymentMethodId);

  // ONLY SAVE NEW PAYMENT METHODS
  if (!isSavedPayment) {

    const saveResult = await savePaymentMethod(
      paymentMethodId
    );

    if (!saveResult.status) {
      Store.dispatch(
        setNewToast({
          body: saveResult.message,
          variant: "danger",
        })
      );

      return;
    }
}

// CREATE SUBSCRIPTION
    Subscription.store({
      store_id: store?.id,
      payment_card: paymentMethodId,
      plan: filteredPlan?.id,
      coupon_code: appliedCoupon
        ? appliedCoupon?.id
        : null,
    })
    .then(responseValidate)
    .then((result) => {
      if (result.status) {

        fetchPaymentMethods();

        Store.dispatch(
          setNewToast({
            body: result.message,
            variant: "success",
          })
        );

        setTimeout(() => {
          window.location.reload();
        }, 3000);

      } else {
        Store.dispatch(
          setNewToast({
            body: result.message,
            variant: "danger",
          })
        );
      }
    });
};


  useEffect(() => {
    if (subscriptions && subscriptions.prices && subscriptions.prices.length > 0) {
      const selectedPlan = subscriptions.prices.find((price) => {
        if (billingCycle === 'Monthly' && price.recurring.interval === 'month') {
          return true;
        }
        if (billingCycle === 'Yearly' && price.recurring.interval === 'year') {
          return true;
        }
        return false;
      });
      if (selectedPlan) {
        setFilteredPlan(selectedPlan);
      } else {
        setFilteredPlan(null);
      }
    }
  }, [billingCycle, subscriptions]);

  useEffect(() => {
  if (loading) return;

  const initPayment = async () => {

    const hasSavedPayments =
      (savedCards && savedCards.length > 0) ||
      (savedACH && savedACH.length > 0);

    if (hasSavedPayments) {
      setPaymentType('payment-saved');
    } else {
      // default ACH
      setPaymentType('new-ach');

      if (!clientSecret) {
        await createSetupIntent();
      }
    }
  };

  initPayment();

}, [loading, savedCards, savedACH]);
  

  useEffect(() => {
    if (store?.store_subscription && subscriptions?.prices) {
      const selectedPrice = subscriptions.prices.find(
        (price) => store.store_subscription.stripe_price === price.id
      );

      if (selectedPrice) {
        const basePrice = selectedPrice.unit_amount / 100;
        setPlanPrice(basePrice); 
        setPlan(selectedPrice.id);
        setPlanDetails(selectedPrice.recurring.interval);
        setCurrentPlan(selectedPrice.recurring.interval === 'month' ? 'Monthly' : 'Yearly')
        if(selectedPrice.recurring.interval === 'month') setBillingCycle('Monthly'); else setBillingCycle('Yearly');
      }
    }
  }, [store?.store_subscription, subscriptions]);
  
  useEffect(() => {
    if (location.pathname !== '/') {
      history.push('/');
    }
  }, [location, history]);
  
  const subscriptionMessage = useMemo(() => {
    const sub = store.store_subscription;

    return sub.stripe_id.startsWith('temp_sub_')
      ? 'Your free trial has ended. Please make payment to continue using Hisably.'
      : 'Your subscription has ended. Please renew now to continue using Hisably.';
  }, [store]);




  return (   
      <div className="container mt-4">
        <Card style={{ margin: '0 auto', borderRadius: '10px', maxWidth: '1000px' }}>
          <Card.Body className='p-0'>
            {!showPaymentMethod &&  (<div className='subscription-ended-container p-4 p-lg-5' style={{ marginBottom: '0', borderRadius: '8px' }}>
            {store?.store_subscription && (
              <>
                <h5 style={{ fontWeight: 'bold', marginBottom: '20px' }}>Hisably Subscription</h5>
                <h6 style={{ fontWeight: 'bold',color:'red' }}> {subscriptionMessage}</h6>
                <hr />
                <div style={{ textAlign: 'left',fontSize:'15px' }}>
                <p ><strong>Existing Plan:</strong> {currentPlan ? currentPlan: 'Not Available'}</p>
                  
                  {/* Highlight Status */}
                  <p>
                    <strong>Status:</strong> 
                    <span 
                      style={{
                        fontWeight: 'bold', 
                        color: status === 'active' ? 'green' : 'red', 
                        backgroundColor: status === 'active' ? '#e8f5e9' : '#f8d7da', 
                        padding: '4px 8px', 
                        borderRadius: '4px',
                        marginLeft:'5px'
                      }}
                    >
                    {status || 'Not Available'}
                    </span>
                  </p>

                  <p><strong>Price:</strong> ${planPrice || 0}</p>
                </div>
              </>
             
            )}
          <hr></hr>
           {
            loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                <Spinner animation="border" role="status" variant="primary">
                </Spinner>
              </div>
            ) :(
          <div className="subscription-container">
            <Row className='justify-content-center mb-n4'>
            {
              subscriptions?.prices?.map(row => {
                
                // if (planDetails && planDetails === 'year' && row.recurring.interval === 'month') {
                //   return null;  
                // }
                const basePrice = row.unit_amount / 100;
                const totalPrice = basePrice;

                const handleSelectPlan = () => {
                  setPlan(row.id);
                  setBillingCycle(row.recurring.interval === 'month' ? 'Monthly' : 'Yearly');
                };
                
                
                return (
                  <Col key={row.id} md={6} lg={5} className='mb-4'>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        onChange={handleSelectPlan}
                        name="planRadios"
                        id={row.id}
                        checked={plan === row.id && billingCycle === (row.recurring.interval === 'month' ? 'Monthly' : 'Yearly')}
                      />
                      <label className="form-check-label subscription-box-label shadow-2" htmlFor={row.id}>
                        <h3 className="subscription-title" style={{ textTransform: 'capitalize' }}>
                          {row.recurring.interval}ly Plan
                        </h3>
                        <span className="subscription-price">
                          ${totalPrice}/{row.recurring.interval}
                        </span>
                        {
                          row.recurring.interval === 'month' ?
                          <span className="subscription-detail">It's only $1 per Day!</span> :
                          <span className="subscription-detail">Go Annual and get 10% discount!</span>
                        }
                        <div className="subscription-btn mt-2">Select Plan</div>
                      </label>
                    </div>
                  </Col>
                );
              })
            }

            </Row>
          </div>)}

            {!loading && filteredPlan && (
              <div className="mt-4 d-flex justify-content-end">
                  <Button
                    variant="primary"
                    onClick={() => setShowPaymentMethod(true)} // Show payment method section
                  >
                    Next
                  </Button>
              </div>
            )}
             </div>)}
            {showPaymentMethod && (
                <Row className="mx-0">
                  {/* Display the selected plan details */}
                  <Col xs={12} md={6} className="p-0" style={{borderRadius: '8px' }}>
                    <div className='subscription-step-2-container-wrapper position-relative' style={{ backgroundColor: darkMode ? '#333333' : '#f8f9fa' }}>
                      <button
                        className='btn-icon btn-white'
                        onClick={() => setShowPaymentMethod(false)}
                        >
                        <i className="fas fa-arrow-left"></i>
                      </button>
                      {filteredPlan && (
                        <div className='subscription-step-2-container mt-4' >
                          <p className='mb-0' style={{
                              fontSize: '1rem',
                              fontWeight: 'bold',
                              color: darkMode ? '#e0e0e0' : '#888888',
                            }}>Subscribe to Hisably Subscription</p>
                          <p style={{
                              fontSize: '2rem',
                              fontWeight: 'bold',
                              margin: '0.5rem 0',
                              color: '#01bf9d', // Blue to indicate price
                            }}>${(
                              filteredPlan.unit_amount / 100).toFixed(2)} <p style={{
                              fontSize: '1rem',
                              display: 'inline-block',
                              fontWeight: 'normal',
                              margin: '0',
                              color: darkMode ? '#e0e0e0' : '#000000',
                            }}>{billingCycle}</p></p>
                            {
                              filteredPlan?.recurring?.interval === 'month' ? (
                                <p className='d-block'
                                      style={{
                                        fontSize: '0.8rem',
                                        fontWeight: 'normal',
                                        color: '#888',
                                        margin: '0.25rem 0',
                                      }}
                                    >
                                  Save 10% when billed annually
                                </p>
                              ):(
                                <p className='d-block'
                                      style={{
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold',
                                        color: '#01bf9d',
                                        margin: '0.25rem 0',
                                      }}
                                    >
                                  Smart choice — enjoy 10% savings with annual billing.
                                </p>
                              )
                            }
                          {/* <h5 
                            style={{
                              fontWeight: 'bold',
                              marginBottom: '1rem',
                            }}
                          >
                            Selected Plan
                          </h5> */}
                          <table className='text-md table mt-4 mb-0'>
                            <tbody>
                              <tr style={{ backgroundColor: darkMode ? '#333333' : '#f8f9fa' }}>
                                <td className='pl-0 border-top-0 font-weight-bolder'>Selected Plan</td>
                                <td className='pr-0 border-top-0 font-weight-bolder text-right'>{billingCycle}</td>
                              </tr>
                              <tr style={{ backgroundColor: darkMode ? '#333333' : '#f8f9fa' }}>
                                <td className='pl-0 font-weight-bolder'>Selected Plan Price</td>
                                <td className='pr-0 font-weight-bolder text-right'>${filteredPlan.unit_amount / 100}</td>
                              </tr>
                              <tr style={{ backgroundColor: darkMode ? '#333333' : '#f8f9fa' }}>
                                <td className='pl-0 font-weight-bolder'>Total</td>
                               <td className='pr-0 text-right font-weight-bolder'>
                                  {appliedCoupon ? (
                                    <>
                                      <del className="text-muted mr-2">
                                        ${(filteredPlan.unit_amount / 100).toFixed(2)}
                                      </del>
                                      <span style={{ color: '#28a745' }}>
                                        ${(
                                          (appliedCoupon.percent_off > 0
                                            ? (filteredPlan.unit_amount / 100 * (1 - appliedCoupon.percent_off / 100))
                                            : Math.max(0, (filteredPlan.unit_amount / 100 - (appliedCoupon.amount_off || 0)))
                                          )).toFixed(2)}
                                      </span>
                                    </>
                                  ) : (
                                    `$${(filteredPlan.unit_amount / 100).toFixed(2)}`
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div className="coupon-section mt-4">
                            {!appliedCoupon && (
                              <h4 
                                style={{ color: '#01bf9d', cursor: 'pointer', fontWeight: '700', marginBottom: '10px', userSelect: 'none' }} 
                                onClick={() => setShowCouponInput(!showCouponInput)}
                              >
                                Have a referral code?
                              </h4>
                            )}

                            {(showCouponInput || appliedCoupon) && (
                              <>
                                {appliedCoupon && <h6 style={{ color: '#01bf9d', cursor: 'pointer', fontWeight: '700', marginBottom: '10px', userSelect: 'none' }} >Have a referral code?</h6>}
                                <div className="d-flex border rounded p-1" style={{ backgroundColor: darkMode ? '#1e1e1e' : '#fff' }}>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Referral Code"
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                    className="border-0 shadow-none"
                                    style={{ backgroundColor: 'transparent', color: darkMode ? '#e0e0e0' : '#000' }}
                                    disabled={appliedCoupon}
                                  />
                                  {appliedCoupon ? (
                                    <Button
                                      variant="link"
                                      className="text-danger p-0 px-2 text-decoration-none"
                                      onClick={() => {
                                        setAppliedCoupon(null);
                                        setCouponCode('');
                                        setShowCouponInput(false);
                                      }}
                                    >
                                      Remove
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      onClick={handleApplyCoupon}
                                      disabled={isApplyingCoupon || !couponCode}
                                      style={{ minWidth: '70px', borderRadius: '4px' }}
                                    >
                                      {isApplyingCoupon ? <Spinner size="sm" animation="border" /> : 'Apply'}
                                    </Button>
                                  )}
                                </div>
                              </>
                            )}
                            {couponError && <small className="text-danger mt-1 d-block">{couponError}</small>}
                            {appliedCoupon && (
                              <small className="text-success mt-1 d-block">
                                referral code "{appliedCoupon?.id}" applied! {
                                  appliedCoupon?.percent_off > 0
                                    ? `${appliedCoupon?.percent_off}% off`
                                    : `$${appliedCoupon?.amount_off} off`
                                } on base plan.
                              </small>
                            )}
                          </div>
                          
                        </div>
                      )}
                    </div>
                  </Col>
                  
                <Col xs={12} md={6} className="p-0">
                    <div className={`${darkMode ? "dark-mode" : ""}`}>
                      <div className="p-3 p-md-4 p-lg-5">
                        <h6 style={{ fontWeight: "bold", marginBottom: "10px" }}>
                          Payment method
                        </h6>

                        <div className="payment-border">

                          {/* SAVED PAYMENT */}
                          {((savedCards && savedCards.length > 0) ||
                            (savedACH && savedACH.length > 0)) && (
                            <div className="payment-item">
                              <div
                                className="payment-radio-box"
                                onClick={() => {
                                  handlePaymentTypeChange("payment-saved");
                                }}
                              >
                                <input
                                  type="radio"
                                  checked={paymentType === "payment-saved"}
                                  readOnly
                                />

                                <h6 className="mb-0">Saved Payment</h6>
                              </div>

                              <Collapse in={paymentType === "payment-saved"}>
                              <div className="subscription-payment-method-container">
                                <div className="payment-collapse">

                                  {/* SAVED PAYMENT LIST */}

                                    <PaymentMethodSelector
                                      savedCards={savedCards}
                                      savedACH={savedACH}
                                      selected={selectedSavedPayment}
                                      onSelect={(paymentMethodId) => {
                                        setSelectedSavedPayment(paymentMethodId);
                                      }}
                                    />
                                    <div className="mt-3 d-flex justify-content-end">
                                    <Button
                                      variant="primary"
                                      disabled={!selectedSavedPayment}
                                      onClick={() => subscribeNow(selectedSavedPayment)}
                                    >
                                      Start Subscription
                                    </Button>
                                    </div>

                                  </div>
                                </div>
                              </Collapse>
                            </div>
                          )}

                          {/* NEW US BANK ACCOUNT */}
                          <div className="payment-item">
                            <div
                              className="payment-radio-box"
                              onClick={() => {
                                handlePaymentTypeChange("new-ach");
                              }}
                            >
                              <input
                                type="radio"
                                checked={paymentType === "new-ach"}
                                readOnly
                              />

                              <h6 className="mb-0">US Bank Account</h6>
                            </div>

                            <Collapse in={paymentType === "new-ach"}>
                              <div className="payment-collapse">
                                {clientSecret && (
                                  <StripeWrapper
                                    options={{
                                      clientSecret,
                                      appearance: {
                                        theme: darkMode ? "night" : "stripe",
                                        variables: {
                                          colorPrimary: darkMode ? "#ffffff" : "#000000",
                                          colorBackground: darkMode ? "#1e1e1e" : "#ffffff",
                                          colorText: darkMode ? "#e0e0e0" : "#000000",
                                          colorDanger: "#df1b41",
                                        },
                                      },
                                    }}
                                  >
                                    {/* <div className="subscription-payment-method-container"> */}
                                      <BankPaymentForm
                                        darkMode={darkMode}
                                        onSuccess={(paymentMethodId) => {
                                          subscribeNow(paymentMethodId);
                                        }}
                                      />
                                    {/* </div> */}
                                  </StripeWrapper>
                                )}
                              </div>
                            </Collapse>
                          </div>

                          {/* NEW CARD */}
                          <div className="payment-item">
                            <div
                              className="payment-radio-box"
                              onClick={() => {
                                handlePaymentTypeChange("card-new");
                              }}
                            >
                              <input
                                type="radio"
                                checked={paymentType === "card-new"}
                                readOnly
                              />

                              <h6 className="mb-0">Card</h6>
                            </div>

                            <Collapse in={paymentType === "card-new"}>
                              <div className="payment-collapse">
                                <StripeWrapper>
                                  {/* <div className="subscription-payment-method-container"> */}

                                    <CardPaymentForm
                                      darkMode={darkMode}
                                      onSuccess={(paymentMethodId) => {
                                        subscribeNow(paymentMethodId);
                                      }}
                                    />

                                  {/* </div> */}
                                </StripeWrapper>
                              </div>
                            </Collapse>
                          </div>

                        </div>
                      </div>
                    </div>
                  </Col>
                  {/* <Col xs={12} md={6} className="mb-4">
                    <Button
                      variant="primary"
                      onClick={() => setShowPaymentMethod(false)} // Show payment method section
                    >
                      Back
                    </Button>
                  </Col> */}
                    
                </Row>
              )}
          </Card.Body>
        </Card>
      </div>
  );
};


const mapStateToProps = state => ({
  store: state.App.store,
  darkMode: state.App.darkMode,
});

export default connect(mapStateToProps)(SubscriptionPage);

